import VacancyWizard from './VacancyWizard.component';

export default VacancyWizard;
